export default "{\n    \"impersonateOwner\": \"Se faire passer pour le propri\\u00e9taire\"\n}\n"